/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
/**
 * Finds a value in the array matching the query function.
 * If a match for the query is found, we replace the value
 * If a match for the query is NOT found we PUSH it into the array
 * @param arr
 * @param queryFn
 * @param value
 */
export function pushOrReplaceValue(arr, queryFn, value) {
    var match = arr.find(queryFn);
    if (match) {
        var index = arr.indexOf(match);
        arr.splice(index, 1, value);
    }
    else {
        arr.push(value);
    }
}
/**
 * Finds a value in the array matching the query function.
 * If a match for the query is found, we replace the value
 * If a match for the query is NOT found we UNSHIFT it into the array
 * @param arr
 * @param queryFn
 * @param value
 */
export function unshiftOrReplaceValue(arr, queryFn, value) {
    var match = arr.find(queryFn);
    if (match) {
        var index = arr.indexOf(match);
        arr.splice(index, 1, value);
    }
    else {
        arr.unshift(value);
    }
}
//# sourceMappingURL=arrays.js.map